










import { Component, Vue, Watch, Provide, Prop } from "vue-property-decorator";
@Component({
  name: "MaskComponent.vue"
})
export default class Mask extends Vue {
  // @Provide() public isMask!: boolean; // 遮罩层
  // 关闭遮罩
  public hideMask(val: any) {
    this.$emit("hideMask", {
      hidden: false
    });
  }
}
